import { Button } from '@/components/Button'

export interface OCRBulkActionButtonProps {
  bulkActionName: string
  isDisabled: boolean
  onPress: () => unknown
}

export function OCRBulkActionButton({
  bulkActionName,
  isDisabled,
  onPress,
}: OCRBulkActionButtonProps) {
  return (
    <Button
      label={bulkActionName}
      size="wide-slim"
      variant="primary"
      isDisabled={isDisabled}
      onPress={onPress}
    />
  )
}
